import React from "react";
import "./EraPage.css";

function ModernWorld() {
  return (
    <div className="era-page">
      {/* Banner */}
      <div className="era-banner modernworld-banner">
        <h1>🌐 Modern World: Canada & The Global Stage</h1>
        <p className="era-subtitle">Grade 9 - Exploring Canada’s Role in a Changing World</p>
      </div>

      {/* Overview */}
      <section className="modernworld-overview">
        <h2>🗺️ What is the Modern World Era?</h2>
        <p>
          The Modern World Era focuses on the 21st century and how countries work together
          to solve problems like climate change, wars, and global health. Canada plays an
          important role in peacekeeping, international trade, and working with the United Nations.
        </p>
      </section>

      {/* Key Events & Concepts */}
      <section className="modernworld-key">
        <h2>🌟 Key Themes & Figures</h2>
        <ul>
          <li>🌍 <strong>Globalization:</strong> The world is more connected than ever through trade, technology, and travel.</li>
          <li>☮️ <strong>Canada's Peacekeeping:</strong> Helping countries solve conflicts peacefully.</li>
          <li>🌱 <strong>Climate Action:</strong> Working with others to fight climate change.</li>
          <li>💼 <strong>Global Trade:</strong> Canada buys and sells goods with countries around the world.</li>
          <li>🏥 <strong>Global Health:</strong> Working together during pandemics (like COVID-19).</li>
        </ul>
      </section>

      {/* Mini Story */}
      <section className="modernworld-story">
        <h2>📖 Story: “Voices from Afar”</h2>
        <p>
          A girl named <strong>Layla</strong> in Toronto video chats with her cousin <strong>Zahid</strong> in Pakistan. 
          They talk about school, weather, and even the games they play. Though oceans apart, they realize 
          how connected the world has become — they’re even using the same phone apps!
        </p>
      </section>

      {/* Video Section */}
      <section className="modernworld-media">
        <h2>🎥 Watch & Learn</h2>
        <img
    className="modernworld-illustration"
    src="/images/modernworld-era-scene.png" // Make sure this matches your actual path/filename
    alt="Diverse children holding hands around a globe with Canada highlighted, peace doves, video chat, and green technology"
    style={{
      width: "100%",
      maxWidth: 500,
      borderRadius: "1.5rem",
      margin: "0 auto",
      boxShadow: "0 4px 24px rgba(0,0,0,0.12)"
    }}
  />
      </section>

      {/* Quiz */}
      <section className="modernworld-quiz">
        <h2>❓ Quick Questions!</h2>
        <ol>
          <li>What is globalization?</li>
          <li>How does Canada help in international peacekeeping?</li>
          <li>Name one issue Canada works with other countries to solve.</li>
        </ol>
        <p><em>(Talk about your answers with your classmates or family!)</em></p>
      </section>

      {/* Timeline */}
      <section className="modernworld-timeline">
        <h2>📅 Timeline of Recent World Events</h2>
        <ul>
          <li>2001 – 9/11 attacks and global security changes</li>
          <li>2015 – Paris Climate Agreement</li>
          <li>2020 – Global COVID-19 Pandemic</li>
          <li>2023 – Canada commits to more renewable energy</li>
        </ul>
      </section>
    </div>
  );
}

export default ModernWorld;
